import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function KararVermeTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['karar-verme-guclugu-testi']} />;
}
